module.exports = __webpack_public_path__ + "img/y_p3_z1.a6078574.png";